/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { __core_private__ as r } from '@angular/core';
export var isDefaultChangeDetectionStrategy = r.isDefaultChangeDetectionStrategy;
export var ChangeDetectorStatus = r.ChangeDetectorStatus;
export var LifecycleHooks = r.LifecycleHooks;
export var LIFECYCLE_HOOKS_VALUES = r.LIFECYCLE_HOOKS_VALUES;
export var ReflectorReader = r.ReflectorReader;
export var ViewContainer = r.ViewContainer;
export var CodegenComponentFactoryResolver = r.CodegenComponentFactoryResolver;
export var ComponentRef_ = r.ComponentRef_;
export var AppView = r.AppView;
export var DebugAppView = r.DebugAppView;
export var NgModuleInjector = r.NgModuleInjector;
export var registerModuleFactory = r.registerModuleFactory;
export var ViewType = r.ViewType;
export var view_utils = r.view_utils;
export var DebugContext = r.DebugContext;
export var StaticNodeDebugInfo = r.StaticNodeDebugInfo;
export var devModeEqual = r.devModeEqual;
export var UNINITIALIZED = r.UNINITIALIZED;
export var ValueUnwrapper = r.ValueUnwrapper;
export var TemplateRef_ = r.TemplateRef_;
export var RenderDebugInfo = r.RenderDebugInfo;
export var Console = r.Console;
export var reflector = r.reflector;
export var Reflector = r.Reflector;
export var ReflectionCapabilities = r.ReflectionCapabilities;
export var NoOpAnimationPlayer = r.NoOpAnimationPlayer;
export var AnimationPlayer = r.AnimationPlayer;
export var AnimationSequencePlayer = r.AnimationSequencePlayer;
export var AnimationGroupPlayer = r.AnimationGroupPlayer;
export var AnimationKeyframe = r.AnimationKeyframe;
export var AnimationStyles = r.AnimationStyles;
export var ANY_STATE = r.ANY_STATE;
export var DEFAULT_STATE = r.DEFAULT_STATE;
export var EMPTY_STATE = r.EMPTY_STATE;
export var FILL_STYLE_FLAG = r.FILL_STYLE_FLAG;
export var prepareFinalAnimationStyles = r.prepareFinalAnimationStyles;
export var balanceAnimationKeyframes = r.balanceAnimationKeyframes;
export var clearStyles = r.clearStyles;
export var collectAndResolveStyles = r.collectAndResolveStyles;
export var renderStyles = r.renderStyles;
export var ViewMetadata = r.ViewMetadata;
export var ComponentStillLoadingError = r.ComponentStillLoadingError;
export var AnimationTransition = r.AnimationTransition;
//# sourceMappingURL=private_import_core.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/compiler/src/private_import_core.js
// module id = 14
// module chunks = 0